module.exports = __webpack_public_path__ + "static/media/downArrow.8b5b4e5d.png";